import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  standalone: false,
  templateUrl: './blank-layout.component.html',
  styleUrl: './blank-layout.component.scss'
})
export class BlankLayoutComponent {

}
